// src/api/features/payment-links/types.ts

/* =========================
 * PAYMENT LINKS — Types & Contracts
 * ========================= */

export type PaymentLinkStatus =
  | "DRAFT"
  | "SENT"
  | "PAID"
  | "EXPIRED"
  | "CANCELLED"
  | "FAILED"
  | "REFUNDED"
  | "PARTIALLY_REFUNDED";

export namespace PaymentLinkDTO {
  /** Create payload accepted by the API */
  export interface Create {
    amount: number;
    currencyCode?: string;
    customerName: string;
    customerEmail?: string | null;
    customerPhone?: string | null;
    description: string;
    reference?: string | null;
    expiresAt?: string | null; // ISO datetime
    sendEmail?: boolean;
  }

  export interface Refund {
    amount?: number | null; // omit for full refund
    reason?: string | null;
  }

  export interface ListParams {
    page?: number;
    pageSize?: number;
    q?: string;
    status?: PaymentLinkStatus;
  }

  export interface Page<T> {
    items: T[];
    total: number;
    page: number;
    pageSize: number;
  }
}

/** UI model (view layer) */
export interface PaymentLink {
  id: number;
  linkCode: string;
  provider: string;
  status: PaymentLinkStatus;
  orderId: string | null;
  amount: string; // major units as string, e.g. "1300.00"
  currencyCode: string;
  customerName: string | null;
  customerEmail: string | null;
  customerPhone: string | null;
  description: string;
  reference: string | null;
  checkoutUrl: string | null;
  refundedAmount: string | null;
  expiresAt: string | null;
  paidAt: string | null;
  cancelledAt: string | null;
  sentAt: string | null;
  sentCount: number;
  createdAt: string;
  createdBy: string | null;
}

/** React Query keys */
export const PaymentLinksKeys = {
  all: ["payment-links"] as const,
  list: (p: Partial<PaymentLinkDTO.ListParams>) =>
    ["payment-links", "list", p] as const,
  detail: (id: number) => ["payment-links", "detail", id] as const,
};
